export default [
  50, 100, 200, 500, 1000,
]
